export function getOrCreateSessionId() {
  let sid = sessionStorage.getItem("nm_session_id");

  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("nm_session_id", sid);
  }

  return sid;
}